var divider_viewer_rtlignore_default = {
  "divider-container": "wbmXk",
  "divider-container--double": "_8b2Xw",
  "divider": "_46DGI",
  "divider--single": "k3AHn",
  "divider--double": "dxnJD",
  "divider--dashed": "IYNnj",
  "divider--dotted": "GdQFj",
  "divider--small": "kt0Cr",
  "divider--medium": "iX4Ny",
  "divider--large": "CXSlZ",
  "divider--left": "a-GIp",
  "divider--center": "yhhH2",
  "divider--right": "truPO",
  "svgFixerContainer": "O4Qt1",
  "emptyChar": "fwQuB"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
